// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__4xW-M","resendInfoText":"OnGoingPaymentBox_resendInfoText__3gHoB"};